import { PropsWithChildren } from "react";

import styles from "./BtnV2.module.scss";

interface IProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "black" | "white" | "white-2" | "purple" | "purple-white" | "weak" | "lavender" | "yellow" | "pink" | "green";
  isDisabled?: boolean;
  isLoading?: boolean;
  icon?: React.ReactNode;
  width?: string;
  padding?: string;
  margin?: string;
  height?: "sub" | "main";
}

/**
 * @param type ? 종류; `"black"`
 * @param isDisabled ? 비활성화 여부; `false`
 * @param isLoading ? 로딩 중 여부; `false`
 */
export default function BtnV2({
  children,
  onClick,
  type = "black",
  icon = null,
  isDisabled = false,
  isLoading = false,
  width = "fit-content",
  padding = "",
  margin = "",
  height = "main",
}: PropsWithChildren<IProps>) {
  return (
    <button
      style={{
        width: width,
        margin,
        padding,
        height: height === "sub" ? "var(--btn-height-sub)" : "var(--btn-height-main)",
      }}
      className={styles.btn}
      data-type={type}
      data-is-disabled={isDisabled}
      data-is-loading={isLoading}
      onClick={(event) => {
        if (isDisabled || isLoading || !onClick) return;
        onClick(event);
      }}
    >
      {isLoading ? (
        <div className={styles.loading}>
          {[1, 2, 3].map((number) => (
            <div key={number} className={styles.dot} data-type={type} data-is-disabled={isDisabled} />
          ))}
        </div>
      ) : (
        <div className={styles["inner-box"]}>
          {icon && <div className={styles["icon"]}>{icon}</div>}
          <span>{children}</span>
        </div>
      )}
    </button>
  );
}
